import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ReduxToken: null,
  ReduxTokenApiGraph: null,
};

export const ReduxTokenSlice = createSlice({
  name: "ReduxToken",
  initialState,
  reducers: {
    chgToken: (state, action) => {
      state.ReduxToken = action.payload;
    },
    chgTokenApiGraph: (state, action) => {
      state.ReduxTokenApiGraph = action.payload;
    },
  },
});

export const { chgToken, chgTokenApiGraph } = ReduxTokenSlice.actions;

export default ReduxTokenSlice.reducer;
